import { ResetIdentitySignInRequestSchema, ResetIdentitySignInResponseSchema } from '../../../../shared/reset-identity-sign-in.schema';
/**
 * Reset Tenant User Sign-In Endpoint Contract (super-admin)
 * Replaces the person's sign-in account and emails a setup link.
 */ export const resetTenantUserSignInContract = {
    method: 'POST',
    path: '/api/v2/tenants/:tenantId/users/:userId/reset-sign-in',
    description: "Reset a tenant user's sign-in (super-admin)",
    requestSchema: ResetIdentitySignInRequestSchema,
    responseSchema: ResetIdentitySignInResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - own account, user not active, sign-in disabled, home org SSO-enforced, deleted or unknown',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user is not a super-admin',
            404: 'User or tenant not found',
            409: 'Conflict - the sign-in identity changed while the reset was running, or an email change has not reached the sign-in account yet',
            503: 'Service Unavailable - identity provider unreachable'
        }
    }
};

//# sourceMappingURL=reset-tenant-user-sign-in.contract.js.map